/** F1 조작법 오버레이. 표 내용은 docs/game-design.md 6장과 같게 유지한다. */

import Phaser from 'phaser';
import { COLOR, TEXT_COLOR, UI_FONT } from './theme';
import { fitText } from './fitText';

const ROWS: readonly [string, string][] = [
  ['← →', '좌우 이동'],
  ['↑ ↓', '사다리 · 밧줄 등반'],
  ['Alt / Space', '점프'],
  ['↓ + Alt', '발판 아래로 내려가기'],
  ['Ctrl', '기본 공격 (전사 베기 · 그 외 투사체)'],
  ['Shift / A / F', '퀵슬롯 스킬'],
  ['K', '스킬 창 (1~4차 칸 · SP · 퀵슬롯)'],
  ['S', '능력치 창 (AP 분배)'],
  ['I', '아이템 창'],
  ['E', '장비 창 (슬롯·강화)'],
  ['1 / 2', 'HP · MP 포션 사용'],
  ['↑ (NPC·포탈)', '대화 / 다른 맵으로 이동'],
  ['전직관', '마을. 대화 후 1/2/3 또는 패드 S1~S3'],
  ['U', '칭호 창 (해금·착용)'],
  ['Q', '퀘스트 로그'],
  ['M', '소리 켜기 / 끄기'],
  ['T / Enter', '채팅 (온라인, 한글 IME)'],
  ['L', '친구 목록 · 닉네임 변경'],
  ['P', '근처 유저 파티 초대'],
  ['F11', '전체화면 / 창 모드'],
  ['F1 또는 H', '이 도움말 (Esc 로 닫기)'],
  ['F3', '설정 (흔들림·숫자·키)'],
  ['F4', '맵 에디터'],
  ['F6 / F7', '입력 재생 / 녹화'],
  ['F8 / G', '트레이닝 / 무적'],
  ['J', '도전 과제'],
  ['가상 패드', '폰: 이동·점프·공격·창 버튼 (6.1)'],
  ['상태 아이콘', '기절 · 슬로우 · 중독 (하단 HP 오른쪽)'],
  ['사망 후 1 / 2', '이 맵 부활 / 헤네시스 마을 부활'],
];

export class HelpOverlay {
  private readonly container: Phaser.GameObjects.Container;

  constructor(scene: Phaser.Scene) {
    const w = 560;
    const rowH = 22;
    const h = 56 + ROWS.length * rowH;
    const x = (scene.scale.width - w) / 2;
    const y = Math.max(24, (scene.scale.height - h) / 2 - 20);

    this.container = scene.add.container(x, y).setVisible(false);

    const g = scene.add.graphics();
    g.fillStyle(COLOR.panelEdge, 0.96);
    g.fillRoundedRect(-4, -4, w + 8, h + 8, 12);
    g.fillStyle(COLOR.panel, 0.98);
    g.fillRoundedRect(0, 0, w, h, 10);
    g.lineStyle(2, COLOR.panelLight, 1);
    g.strokeRoundedRect(0, 0, w, h, 10);
    this.container.add(g);

    const title = scene.add.text(w / 2, 18, '조작 방법', {
      fontFamily: UI_FONT,
      fontSize: '18px',
      color: TEXT_COLOR.gold,
    });
    title.setOrigin(0.5, 0);
    this.container.add(title);

    ROWS.forEach(([key, desc], i) => {
      const yy = 48 + i * rowH;
      const k = scene.add.text(16, yy, key, {
        fontFamily: UI_FONT,
        fontSize: '13px',
        color: TEXT_COLOR.gold,
      });
      fitText(k, 148, 10);
      const d = scene.add.text(168, yy, desc, {
        fontFamily: UI_FONT,
        fontSize: '13px',
        color: TEXT_COLOR.bright,
        wordWrap: { width: w - 184, useAdvancedWrap: true },
      });
      this.container.add([k, d]);
    });
  }

  toggle(): boolean {
    this.container.setVisible(!this.container.visible);
    return this.container.visible;
  }

  close(): void {
    this.container.setVisible(false);
  }

  get visible(): boolean {
    return this.container.visible;
  }
}
